export default __webpack_public_path__ + "static/mobile-hero-image-fans-6d8709aa85dd3dc7bd32a54c50f3209b.webp";